module.exports = __webpack_public_path__ + "img/6.ae1ed0bf.png";